/** @file IMAGE_IO_ERRORS: the error codes image-io throws through std's throwError. */

/** Every code image-io throws (`throwError(IMAGE_IO_ERRORS.X, params, { path })`); paths are `/png/<chunk>` or `/gif/...`. */
export const IMAGE_IO_ERRORS = {
  PNG_SIGNATURE: 'PNG_SIGNATURE', PNG_CRC: 'PNG_CRC', PNG_CHUNK_ORDER: 'PNG_CHUNK_ORDER',
  PNG_INTERLACE_UNSUPPORTED: 'PNG_INTERLACE_UNSUPPORTED', PNG_BIT_DEPTH: 'PNG_BIT_DEPTH', PNG_COLOR_TYPE: 'PNG_COLOR_TYPE',
  PNG_FILTER: 'PNG_FILTER', PNG_TRUNCATED: 'PNG_TRUNCATED', PNG_INFLATE: 'PNG_INFLATE', PNG_TOO_LARGE: 'PNG_TOO_LARGE', ZLIB_UNAVAILABLE: 'ZLIB_UNAVAILABLE',
  GIF_FRAME_SIZE: 'GIF_FRAME_SIZE', GIF_EMPTY: 'GIF_EMPTY', GIF_SIGNATURE: 'GIF_SIGNATURE', GIF_TRUNCATED: 'GIF_TRUNCATED',
  GIF_INTERLACE_UNSUPPORTED: 'GIF_INTERLACE_UNSUPPORTED', PACK_TOO_WIDE: 'PACK_TOO_WIDE',
} as const;
